import React, { PureComponent } from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'

import listingStyles from './styles/listing.scss'
import adminStyles from './styles/admin.scss'

export default class BottomBarListSelection extends PureComponent {
  handleDeselect = e => {
    e.preventDefault()

    this.props.onDeselect()
  }

  render() {
    const { isVisible, selectedCount, children } = this.props

    if (!isVisible) {
      return <div className={listingStyles.selections} style={{ bottom: -500, height: 160 }} />
    }

    return (
      <div className={listingStyles.selections}>
        <section className={adminStyles.container}>
          <Row>
            <Col sm={8}>
              <h3>
                {i18next.t('actions_for_selected')}&nbsp;
                <small>
                  {selectedCount} {i18next.t('pcs')},{' '}
                  <a href="#" onClick={this.handleDeselect}>
                    {i18next.t('deselect')}
                  </a>
                </small>
              </h3>

              {children}
            </Col>
          </Row>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBarListSelection.js